import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpStatusCode} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {inject} from '@angular/core';
import {throwError} from 'rxjs';
import {AuthenticationService} from '~local/app/shared/services/authentication.service';

export const errorHandlerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    const authService = inject(AuthenticationService);

    return next(req).pipe(catchError((errorResponse: Readonly<HttpErrorResponse>) => {
        if (errorResponse.status === HttpStatusCode.Unauthorized) {
            authService.logout();
        }
        return throwError(() => errorResponse);
    }));
};
